import React from "react";
import PolicyPage from "./PolicyPage";
import { policies } from "../Datas/policyData";

function Delivery() {
  return <PolicyPage policy={policies.delivery} />;
}

export default Delivery;
